import ReviewRating from './ReviewRating';

export default ReviewRating;
